// The OnScrollHook allows you to execute JS commands set in the `data-on-scroll-down` and
// `data-on-scroll-up` data attributes on scroll events.
//
// Example:
//
// <div
//   id="example"
//   phx-hook="OnScrollHook"
//   data-on-scroll-down={JS.hide()}
//   data-on-scroll-up={JS.show()}
// >

import { throttle } from "../utils";

const OnScrollHook = {
  handleScroll() {
    const currentScrollPos = window.scrollY;

    if (this.prevScrollPos > currentScrollPos) {
      const scrollUpAction = this.el.getAttribute("data-on-scroll-up");
      if (scrollUpAction) {
        this.liveSocket.execJS(this.el, scrollUpAction);
      }
    } else {
      const scrollDownAction = this.el.getAttribute("data-on-scroll-down");
      if (scrollDownAction) {
        this.liveSocket.execJS(this.el, scrollDownAction);
      }
    }
    this.prevScrollPos = currentScrollPos;
  },

  mounted() {
    this.prevScrollPos = window.scrollY;
    this.handleScroll = throttle(this.handleScroll.bind(this), 200); // Throttle the handleScroll method to every 200 ms

    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};

export default OnScrollHook;
